// extracted by mini-css-extract-plugin
export var table = "_wg-0";